import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

const TeamDirectoryModal = ({ skillsInput, setSkillsInput, languages, setLanguages,
    languagesInput, setLanguagesInput, hobbiesInput, setHobbiesInput, skills,
    setSkills, weeklyHoliday, setWeeklyHoliday, hobbies_interest, setHobbies, staff,
    setStaff, handleBlurOrEnter, removeTag, weeklyHolidayOptions,
    genderOptions, departmentOptions,
    employmentStatusOptions, maritalStatusOptions, handleChange,
    handleFileChange, handleGenresChange, handleSubmit,
    isOpen, setIsOpen }) => {
    const url = process.env.REACT_APP_LINK

    console.log(staff)
    // Prevent rendering modal if it is not open
    if (!isOpen) {
        return null;
    }

    // Debugging: Log hobbies to see its state
    console.log('Is hobbies array:', Array.isArray(hobbies_interest), hobbies_interest); // Check if 'hobbies' is an array

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"
                Prevent closing on content click
            >
                <h2 className="oms-modal-title">Employee Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    {/* Basic Information */}
                    <h3>Basic Information</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="fullName" className="oms-form-label">First Name</label>
                            <input type="text" id="fullName"
                                name="firstName"
                                value={staff.firstName}
                                onChange={handleChange}
                                placeholder="Enter First Name"
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="fullName" className="oms-form-label">Last Name</label>
                            <input type="text" id="lastName"
                                name="lastName"
                                value={staff.lastName}
                                onChange={handleChange}
                                placeholder="Enter Last Name"
                            />
                        </div>
                        {/* <div className="oms-form-group">
                            <label htmlFor="employeeId" className="oms-form-label">Employee ID</label>
                            <input type="text" id="employeeId" placeholder="Enter employee ID" />
                        </div> */}
                        <div className="oms-form-group">
                            <label htmlFor="dob" className="oms-form-label">Date of Birth</label>
                            <input type="date" id="dob"
                                name="dob"
                                value={staff.dob}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="gender" className="oms-form-label">Gender</label>
                            <Select options={genderOptions} placeholder="Select gender" name="gender"
                                value={genderOptions.find(opt => opt.value === staff.gender)}
                                onChange={(selectedOption) => {
                                    setStaff(prev => ({ ...prev, gender: selectedOption ? selectedOption.value : '' }));
                                }} />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="photo" className="oms-form-label">Photo</label>
                            <input type="file" id="profilePic" accept="image/*"
                                name="profilePic"
                                onChange={handleFileChange}
                            />

                            {typeof staff.profilePic === 'string' && staff.profilePic !== '' && (
                                <div className="image-preview">
                                    <img
                                        src={`${url}/${staff.profilePic}`}
                                        alt="Uploaded Preview"
                                        style={{ width: '80px', height: '80px', marginTop: '10px', borderRadius: '8px' }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Contact Information */}
                    <h3>Contact Information</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="address" className="oms-form-label">Address</label>
                            <input type="text" id="address" placeholder="Enter address"
                                name="address"
                                value={staff.address}
                                onChange={handleChange}
                                
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="phoneNumber" className="oms-form-label">Phone Number</label>
                            <input type="tel" id="phone" placeholder="Enter phone number"
                                name="phone"
                                value={staff.phone}
                                onChange={handleChange}
                                
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="email" className="oms-form-label">Email ID</label>
                            <input type="email" id="email" placeholder="Enter email ID"
                                name="email"
                                value={staff.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="email" className="oms-form-label">Password</label>
                            <input type="text" id="password"

                                name="password"
                                value={staff.password}
                                onChange={handleChange}
                                placeholder="Enter Password"
                                required
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="emergencyPhone" className="oms-form-label">Emergency Phone Number</label>
                            <input type="tel" id="emergencyPhone" placeholder="Enter emergency phone number"
                                name="emergency_contact_phone"
                                value={staff.emergency_contact_phone}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Employment Detail */}
                    <h3>Employment Detail</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="jobTitle" className="oms-form-label">Job Title</label>
                            <input type="text" id="job_title" placeholder="Enter job title"
                                name="job_title"
                                value={staff.job_title}
                                onChange={handleChange}
                                
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="department" className="oms-form-label">Department</label>
                            <Select options={departmentOptions} isMulti placeholder="Select department"
                                value={departmentOptions.filter(option => staff.department.includes(option.value))}
                                onChange={handleGenresChange}
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="dof_joining" className="oms-form-label">Date of Joining</label>
                            <input type="date" id="dof_joining"
                                name="dof_joining"
                                value={staff.dof_joining}
                                onChange={handleChange}
                                
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="employmentStatus" className="oms-form-label">Employment Status</label>
                            <Select
                                options={employmentStatusOptions}
                                placeholder="Select status"
                                value={employmentStatusOptions.find(opt => opt.value === staff.employ_status)}
                                onChange={(selectedOption) => {
                                    setStaff(prev => ({ ...prev, employ_status: selectedOption ? selectedOption.value : '' }));
                                }}
                                required
                            />

                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="reportingManager" className="oms-form-label">Reporting Manager</label>
                            <input type="text" id="reportingManager" placeholder="Enter reporting manager"
                                name="report_manager"
                                value={staff.report_manager}
                                onChange={handleChange}

                                
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="classLocation" className="oms-form-label">Office Location</label>
                            <input type="text" id="class_location" placeholder="Enter Office location"
                                name="class_location"
                                value={staff.class_location}
                                onChange={handleChange}

                                
                            />
                        </div>
                    </div>

                    {/* Professional Information */}
                    <h3>Professional Information</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="qualification" className="oms-form-label">Qualification</label>
                            <input type="text" id="qualifications" placeholder="Enter qualification"
                                name="qualifications"
                                value={staff.qualifications}
                                onChange={handleChange}
                                
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="experience" className="oms-form-label">Previous Experience</label>
                            <input type="text" id="experience" placeholder="Enter previous experience"
                                name="prev_exp"
                                value={staff.prev_exp}
                                onChange={handleChange}
                                 />
                        </div>
                        {/* Skills */}
                        <div className="oms-form-group">
                            <label htmlFor="skills" className="oms-form-label">Skills</label>
                            <input
                                type="text"
                                id="skills"
                                placeholder="Enter skills separated by commas"
                                value={skillsInput} // Raw input text
                                onChange={(e) => setSkillsInput(e.target.value)} // Update raw input
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleBlurOrEnter(setSkills, setSkillsInput, skillsInput, "skills"); // ✨ send "skills"
                                    }
                                }}
                                onBlur={() => handleBlurOrEnter(setSkills, setSkillsInput, skillsInput, "skills")}


                            />
                            <div>
                                {skills.map((skill, index) => (
                                    <span key={index} className="tag">{skill}
                                        <button
                                            type="button"
                                            className="remove-tag-btn"
                                            onClick={() => removeTag(setSkills, index)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            </div>
                        </div>
                        {/* Languages */}
                        <div className="oms-form-group">
                            <label htmlFor="languages" className="oms-form-label">Languages</label>
                            <input
                                type="text"
                                id="languages"
                                placeholder="Enter languages separated by commas"
                                value={languagesInput}
                                onChange={(e) => setLanguagesInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleBlurOrEnter(setLanguages, setLanguagesInput, languagesInput, "language_known"); // ✨ send "language_known"
                                    }
                                }}
                                onBlur={() => handleBlurOrEnter(setLanguages, setLanguagesInput, languagesInput, "language_known")}

                            />
                            <div>
                                {languages.map((language, index) => (
                                    <span key={index} className="tag">{language}
                                        <button
                                            type="button"
                                            className="remove-tag-btn"
                                            onClick={() => removeTag(setLanguages, index)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Payroll Information */}
                    <h3>Payroll Information</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="accountNo" className="oms-form-label">Account Number</label>
                            <input type="text" id="account_no" placeholder="Enter account number"
                                name="account_no"
                                value={staff.account_no}
                                onChange={handleChange}
                                
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="ifscCode" className="oms-form-label">IFSC Code</label>
                            <input type="text" id="ifsc_code" placeholder="Enter IFSC code"
                                name="ifsc_code"
                                value={staff.ifsc_code}
                                onChange={handleChange}
                                
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="bankName" className="oms-form-label">Bank Name</label>
                            <input type="text" id="bank_name" placeholder="Enter bank name"
                                name="bank_name"
                                value={staff.bank_name}
                                onChange={handleChange}
                                
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="providentFund" className="oms-form-label">Provident Fund</label>
                            <input type="text" id="provident_fund_number" placeholder="Enter provident fund number"
                                name="provident_fund_number"
                                value={staff.provident_fund_number}
                                onChange={handleChange}

                            />
                        </div>
                    </div>

                    {/* Other Information */}
                    <h3>Other Information</h3>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label htmlFor="maritalStatus" className="oms-form-label">Marital Status</label>
                            <Select options={maritalStatusOptions} placeholder="Select marital status"
                                value={maritalStatusOptions.find(opt => opt.value === staff.marital_status)}
                                onChange={(selectedOption) => {
                                    setStaff(prev => ({ ...prev, marital_status: selectedOption ? selectedOption.value : '' }));
                                }}
                            />
                        </div>
                        {/* Hobbies */}
                        <div className="oms-form-group">
                            <label htmlFor="hobbies" className="oms-form-label">Hobbies</label>
                            <input
                                type="text"
                                id="hobbies"
                                placeholder="Enter hobbies separated by commas"
                                value={hobbiesInput}
                                onChange={(e) => setHobbiesInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleBlurOrEnter(setHobbies, setHobbiesInput, hobbiesInput, "hobbies_interest"); // ✨ send "hobbies_interest"
                                    }
                                }}
                                onBlur={() => handleBlurOrEnter(setHobbies, setHobbiesInput, hobbiesInput, "hobbies_interest")}

                            />
                            <div>
                                {hobbies_interest.map((hobby, index) => (
                                    <span key={index} className="tag">{hobby}
                                        <button
                                            type="button"
                                            className="remove-tag-btn"
                                            onClick={() => removeTag(setHobbies, index)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="department" className="oms-form-label">Weekly Holiday</label>
                            <Select
                                options={weeklyHolidayOptions}
                                isMulti
                                placeholder="Select weekly holidays"
                                name="weekly_holiday"
                                value={weeklyHolidayOptions.filter(option => staff.weekly_holiday.includes(option.value))}
                                onChange={(selectedOptions) => {
                                    const selectedValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                                    setStaff(prev => ({
                                        ...prev,
                                        weekly_holiday: selectedValues
                                    }));
                                }}
                            />

                        </div>
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TeamDirectoryModal;
